<template>
  <img
    :src="avatar"
    class="avatar"
  >
</template>

<script>
import Mixin from './Mixin'

export default {
  mixins: [
    Mixin
  ],

  data () {
    return {
      avatar: null
    }
  },

  created () {
    const thumbnails = this.model.item.avatar.data.thumbnails
    if (thumbnails) {
      this.avatar = thumbnails[6].url
    }
  },
}
</script>

<style lang="scss" scoped>
.avatar {
  max-width: 100px;
  max-height: 100px;
}
</style>
